import React from 'react';
import {
  Box,
  Container,
  Typography,
  Grid,
  Card,
  CardContent,
  Paper,
  List,
  ListItem,
  ListItemIcon,
  ListItemText
} from '@mui/material';
import { useData } from '../../context/DataContext';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import VisibilityIcon from '@mui/icons-material/Visibility';
import FlagIcon from '@mui/icons-material/Flag';
import hospitalImage from '../../assets/homepageimages/hospital-image.webp';
import PageHero from './PageHero';

const VisionMission = () => {
  const { state } = useData();
  const { pages } = state;
  const visionMissionData = pages['vision-mission'];

  return (
    <Box>
      <PageHero
        src={hospitalImage}
        alt="Vision and Mission"
        title={visionMissionData?.title || 'Vision & Mission'}
        subtitle="Guiding principles that drive our commitment to excellence"
      />

      {/* Main Content */}
      <Container maxWidth="lg" sx={{ py: 8 }}>
        <Grid container spacing={6}>
          {/* Vision Section */}
          <Grid item xs={12} md={6}>
            <Card sx={{ height: '100%', p: 3 }}>
              <CardContent>
                <Box sx={{ display: 'flex', alignItems: 'center', mb: 3 }}>
                  <VisibilityIcon sx={{ fontSize: 40, color: 'primary.main', mr: 2 }} />
                  <Typography variant="h4" component="h2" sx={{ fontWeight: 'bold' }}>
                    Our Vision
                  </Typography>
                </Box>
                <Typography variant="body1" paragraph sx={{ fontSize: '1.1rem', lineHeight: 1.8 }}>
                  {visionMissionData?.vision || 'To be the leading healthcare provider in our region, recognized for excellence in patient care, medical innovation, and community service.'}
                </Typography>
              </CardContent>
            </Card>
          </Grid>

          {/* Mission Section */}
          <Grid item xs={12} md={6}>
            <Card sx={{ height: '100%', p: 3 }}>
              <CardContent>
                <Box sx={{ display: 'flex', alignItems: 'center', mb: 3 }}>
                  <FlagIcon sx={{ fontSize: 40, color: 'primary.main', mr: 2 }} />
                  <Typography variant="h4" component="h2" sx={{ fontWeight: 'bold' }}>
                    Our Mission
                  </Typography>
                </Box>
                <Typography variant="body1" paragraph sx={{ fontSize: '1.1rem', lineHeight: 1.8 }}>
                  {visionMissionData?.mission || 'To provide exceptional healthcare services that improve the quality of life for our patients and their families, while advancing medical knowledge and technology through research and education.'}
                </Typography>
              </CardContent>
            </Card>
          </Grid>
        </Grid>

        {/* Values Section */}
        <Box sx={{ py: 8 }}>
          <Typography variant="h3" component="h2" gutterBottom textAlign="center" sx={{ mb: 6, fontWeight: 'bold' }}>
            Our Core Values
          </Typography>
          <Grid container spacing={3}>
            {(visionMissionData?.values || [
              'Compassionate care for every patient',
              'Excellence in medical treatment',
              'Innovation in healthcare technology',
              'Community-focused healthcare',
              'Professional development for staff',
              'Patient safety as top priority'
            ]).map((value, index) => (
              <Grid item xs={12} sm={6} md={4} key={index}>
                <Card sx={{ 
                  height: '100%', 
                  p: 3,
                  textAlign: 'center',
                  transition: 'transform 0.3s ease, box-shadow 0.3s ease',
                  '&:hover': {
                    transform: 'translateY(-4px)',
                    boxShadow: 4
                  }
                }}>
                  <CardContent>
                    <CheckCircleIcon sx={{ fontSize: 48, color: 'primary.main', mb: 2 }} />
                    <Typography variant="h6" component="h3" sx={{ fontWeight: 600 }}>
                      {value}
                    </Typography>
                  </CardContent>
                </Card>
              </Grid>
            ))}
          </Grid>
        </Box>

        {/* Commitment Section */}
        <Paper sx={{ p: 6, mt: 6, background: 'linear-gradient(135deg, #f8fafc 0%, #e2e8f0 100%)' }}>
          <Typography variant="h4" component="h2" gutterBottom textAlign="center" sx={{ mb: 4, fontWeight: 'bold' }}>
            Our Commitment to You
          </Typography>
          <Typography variant="body1" textAlign="center" sx={{ fontSize: '1.1rem', lineHeight: 1.8, maxWidth: 800, mx: 'auto' }}>
            Every day, we strive to live up to our vision and mission by providing the highest quality healthcare 
            services. Our dedicated team of healthcare professionals works tirelessly to ensure that every patient 
            receives compassionate, personalized care in a safe and healing environment.
          </Typography>
        </Paper>
      </Container>
    </Box>
  );
};

export default VisionMission; 